import { StoreStatus } from "./types";

export function getStatusImg(status: StoreStatus): string {
  if (status === 0) {
    return "/images/icons/ic_dashboard_status-disconnected.png";
  }

  if (status === 1) {
    return "/images/icons/ic_dashboard_status-closed.png";
  }

  if (status === 2) {
    return "/images/icons/ic_dashboard_status-in-operation.png";
  }

  if (status === 3) {
    return "/images/icons/ic_dashboard_status-warning.png";
  }

  return "";
}
